export default {"src":"/_next/static/media/swimming_pool_40.8759c7ce.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};